import { BaseFetch } from "../main-model"
export default class AccumulatedPayModel extends BaseFetch {
    getAccumulatedPayBy = (data) =>
    this.authFetch({
      url: "accumulated-pay/getAccumulatedPayBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getAccumulatedPayById = (data) =>
    this.authFetch({
      url: "accumulated-pay/getAccumulatedPayById",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateAccumulatedPayById = (data) =>
    this.authFetch({
      url: "accumulated-pay/updateAccumulatedPayById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertAccumulatedPay = (data) =>
    this.authFetch({
      url: "accumulated-pay/insertAccumulatedPay",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteAccumulatedPayById = (data) =>
    this.authFetch({
      url: "accumulated-pay/deleteAccumulatedPayById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
